











































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class HeaderNavigationComponent extends Vue {
  // public scrollMeTo(refName) {
  //   // const element = this.$refs[refName];
  //   // const top = element.offsetTop;
  //   //
  //   // window.scrollTo(0, top);
  //
  //   const element = this.$refs[refName];
  //   element.scrollIntoView({ behavior: 'smooth' });
  //
  // }
}
